import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Footer } from '@/common/Footer';
import { AppShellSidebar } from '@/layouts/AppShellSidebar';
import { AppShellTopBar } from '@/layouts/AppShellTopBar';

/**
 * Persistent authenticated layout: sidebar, top bar, main outlet, footer.
 */
export function AppShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const handleOpenMobile = useCallback(() => {
    setMobileNavOpen(true);
  }, []);

  const handleCloseMobile = useCallback(() => {
    setMobileNavOpen(false);
  }, []);

  return (
    <div data-testid="agents-app-shell" className="flex h-full min-h-full bg-canvas font-sans text-primary">
      <AppShellSidebar mobileOpen={mobileNavOpen} onCloseMobile={handleCloseMobile} />

      <div className="flex min-w-0 flex-1 flex-col md:ml-0">
        <AppShellTopBar onOpenMobile={handleOpenMobile} />

        <main
          data-testid="agents-app-shell-main"
          className="flex flex-1 flex-col overflow-y-auto px-4 py-6 md:px-8 md:py-8"
        >
          <div className="mx-auto w-full max-w-5xl flex-1">
            <Outlet />
          </div>

          <div data-testid="agents-app-shell-footer-slot" className="mx-auto mt-8 w-full max-w-5xl pb-4">
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
}
